import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { adminGroups, downloadAdminQrCards } from "@/lib/api";

export default function Part2Tools() {
  const [groups, setGroups] = useState([]);
  const [gid, setGid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    adminGroups().then((gs) => { const p2 = gs.filter((g) => g.part2); setGroups(p2); if (p2[0]) setGid(p2[0].id); }).catch(() => {});
  }, []);

  const cards = async () => {
    if (!window.confirm("New QR cards are generated for every participant in this group. Previously printed cards for this group stop working. Continue?")) return;
    setBusy(true);
    try { await downloadAdminQrCards(gid); toast.success("QR cards downloaded"); }
    catch { toast.error("Could not create QR cards"); }
    finally { setBusy(false); }
  };

  return (
    <div className="rbl-feature" style={{ marginTop: 18 }} data-testid="p2-tools">
      <h3>Training tools</h3>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <Link to="/admin/part2/live" className="rbl-btn green" data-testid="p2-tools-live">📺 Live check-in (beamer)</Link>
        <select className="rbl-input" style={{ width: "auto" }} value={gid} onChange={(e) => setGid(e.target.value)} data-testid="p2-tools-group">
          {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <button className="rbl-btn" disabled={!gid || busy} onClick={cards} data-testid="p2-tools-qr">{busy ? "…" : "🔳 Personal QR cards (PDF)"}</button>
      </div>
      <p style={{ color: "var(--muted)", fontSize: 12, margin: "8px 0 0" }}>QR cards log the participant in directly, valid 14 days. Print, cut and hand them out personally.</p>
    </div>
  );
}
